import { graphql } from "@/lib/gql/__generated__";

export const EcReceiptItemList_ManagementSalesPage_Query = graphql(`
	query EcReceiptItemList_ManagementSalesPage($hotelID: ID!, $startDt: String!, $endDt: String!) {
		ecReceiptItemList(hotelID: $hotelID, startDt: $startDt, endDt: $endDt) {
			id
			list {
				id
				hotelID
				receiptID
				guestName
				guestNameKana
				guestEmail
				guestTel
				guestPostalCode
				guestAddress
				purchasedDate
				totalGuestCharge
				purchasedItems {
					name
					amount
					eachPrice
				}
			}
		}
	}
`);
